module.exports = __webpack_public_path__ + "img/right_reward.9b971111.png";